const isSocialCampaign = campaign => campaign === 'social';

export { isSocialCampaign as default };
